import { useCallback, useEffect, useRef } from 'react'
import type { GaFormHandle } from './GaForm'

type RequestState = {
  isFetching?: boolean
  isSuccess?: boolean
  isError?: boolean
}

export const useDeferredGaSubmit = (
  gaFormRef: React.RefObject<GaFormHandle>,
  request: RequestState | null | undefined,
) => {
  const pendingSubmitRef = useRef(false)
  const {
    isFetching = false,
    isSuccess = false,
    isError = false,
  } = request ?? {}

  const markPending = useCallback(() => {
    pendingSubmitRef.current = true
  }, [])

  useEffect(() => {
    if (!pendingSubmitRef.current) return
    if (isFetching) return
    if (!isSuccess && !isError) return
    gaFormRef.current?.submitGa()
    pendingSubmitRef.current = false
  }, [gaFormRef, isFetching, isSuccess, isError])

  return { markPending }
}
